import React from 'react';
import {
  Box,
  VStack,
  HStack,
  StackDivider,
  Heading,
  Text,
} from '@chakra-ui/react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faBabyCarriage,
  faBuilding,
  faClinicMedical,
  faDumbbell,
  faHandHoldingHeart,
  faPiggyBank,
  faUmbrellaBeach,
} from '@fortawesome/pro-solid-svg-icons';

const BENEFITS = [
  {
    title: 'Compensation',
    description:
      'Competitive salary and meaningful equity in a fast-growing company',
    icon: faBuilding,
  },

  {
    title: 'Healthcare',
    description:
      'Comprehensive medical, dental, and vision coverage for you and dependents',
    icon: faClinicMedical,
  },

  {
    title: 'Paid Time Off',
    description:
      'Unlimited PTO for exempt employees and PTO accrued at 3 weeks per year for non-exempt employees',
    icon: faUmbrellaBeach,
  },

  {
    title: 'Paid Family Leave',
    description:
      'We support work/life balance and offer generous paid parental and new child bonding leave',
    icon: faBabyCarriage,
  },

  {
    title: 'Mandatory Self-Care Days',
    description: 'A day set aside each month to allow employees to recharge',
    icon: faHandHoldingHeart,
  },

  {
    title: 'Remote Wellbeing Resources',
    description:
      'We provide recurring fitness classes, meditation/ mindfulness tools, virtual therapy, and family planning assistance',
    icon: faDumbbell,
  },
  {
    title: 'Learning',
    description:
      'We encourage continued education and will help cover the cost of management training, conferences, workshops, or certifications',
    icon: faPiggyBank,
  },
];

const JobBenefits = () => (
  <>
    <Heading size="xl">Benefits</Heading>
    <VStack
      divider={<StackDivider borderColor="gray.200" />}
      mb="12"
      spacing={[2, 7]}
      align="stretch"
    >
      {BENEFITS.map(({ title, description, icon }) => (
        <HStack mt="10" key={title} alignItems="flex-start">
          <Box mr="3">
            <FontAwesomeIcon icon={icon} color="#6E7694" />
          </Box>
          <Box>
            <Heading fontSize="lg" fontWeight="medium" mb="5">
              {title}
            </Heading>
            <Text color="#6E7694">{description}</Text>
          </Box>
        </HStack>
      ))}
    </VStack>
  </>
);

export default JobBenefits;
